const listaDeAutenticacoes = (state) => {
    return state.items;
}
listaDeAutenticacoes
const loadingAutenticacoes = (state) => {
    return state.carregando;

}

export {
    listaDeAutenticacoes,
    loadingAutenticacoes
}